import React, {useEffect, useRef, useState} from 'react'
import AppRoutes from '../../routes/index'
import {injectIntl} from "react-intl"
import {useDispatch, useSelector} from 'react-redux'
import {getContact} from '../../redux/actions/Company'
import {graphqlContactFields} from "../../utils/constant"
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {userSignOut} from "../../redux/actions/Auth";
import Button from "@mui/material/Button";
import {TawkToConfig} from "../../utils/tawk_to";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import CircularProgress from "@mui/material/CircularProgress";
import SearchIcon from '@mui/icons-material/Search';
import {checkAutoProfileFinished} from "../../redux/api/Talent";
import {wait} from "../../utils/compute";
import {checkJob, clearJobId} from "../../redux/actions/Chatgpt";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import {pagesNav, pagesCompanyNav, pagesAccNav} from "../../utils/nav_company";
import Divider from '@mui/material/Divider';
import {capitalizeFirstLetter} from "../../utils/format";
import CreateTicket from '../../components/common/createTicket'
import platformConfig from '../../config/config'
import { checkBannerMessage, markBannerMessageAsRead } from '../../redux/actions/Talent'
import BannerMessage from '../../components/common/BannerMessage'
import useHasPermissionForRoute from '../../utils/useHasPermissionForRoute'
import useHasPermissionForAction from '../../utils/useHasPermissionForAction'
import LinkedInModal from '../../components/common/LinkedInModal'
import {showLinkedInModal, hideLinkedInModal} from '../../redux/actions/Common'





const CompanyLayout = ({intl}) => {
    const tawkMessengerRef = useRef();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const params = useParams()
    const {pathname} = useLocation();
    const {token, user} = useSelector(({auth}) => auth)
    
    const {locale} = useSelector(({common}) => common)
    const {cguv_en,cguv_fr,protectData_en,protectData_fr} = platformConfig

    const {reupdate_contact, contact} = useSelector(({company}) => company)
    const {bannerMessage} = useSelector(({talent}) => talent)
    const {documents} = useSelector(({file}) => file)
    const {job_offer_id, loading_job, recheck_job, loading_job_done, loading_job_error} = useSelector(({chatgpt}) => chatgpt)
    const {showLinkedInModal: showLinkedInModalState} = useSelector(({common}) => common)
    

    const [currentNav, setCurrentNav] = useState("")
    const [showTalkTo, setShowTalkTo] = React.useState(false);
    const { name,logoPath,disabledPages } = platformConfig;


    const [newNavigation, setNewNavigation] = React.useState(null);
    const [anchorElDynamic, setAnchorElDynamic] = React.useState(null);
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [openDynamic, setOpenDynamic] = React.useState(null);
    const permissions = useHasPermissionForRoute();
    const hasCompanyInfo = useHasPermissionForAction("access-update-company-information-company");
    const hasViewInvoices = useHasPermissionForAction("view-all-invoices");
    const hasManageTeams = useHasPermissionForAction("manage-teams");
    const hasViewCollab = useHasPermissionForAction("view-colleagues");
    const hasEmployerBrand = useHasPermissionForAction("access-employer-brand");

      useEffect(() => {
        dispatch(checkBannerMessage(token));
      }, [dispatch, token]);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseNavMenu = (name) => {
        setAnchorElNav(null);
        navigate('/company/dashboard?tab=' + name);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const Alert = React.forwardRef(function Alert(
        props, ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });


    const handleTawkTo = () => {
        setShowTalkTo(true);
        setTimeout(function() {
            tawkMessengerRef.current.toggle();
        }, 500);
    }

    useEffect(() => {
        if (user && user.type == 'company') {
            dispatch(getContact(token, `
            { 
                contactById(id: "${user.relation}") {
                    ${graphqlContactFields}
                }
            }
        `))
        }

    }, [user, reupdate_contact, documents])

    useEffect(() => {
        if (loading_job && recheck_job > 0) {
            wait(10000).then(() => {
                dispatch(checkJob(token, job_offer_id))
            })
        }
    }, [loading_job, recheck_job])

    useEffect(() => {
        if (newNavigation) {
            setTimeout(function() {
                navigate(newNavigation);
                setNewNavigation(null)
            }, 500);
        }

    }, [newNavigation])

    const getAccessibleNavItems = (pagesNav, permissions) => {
        return pagesNav.filter((nav) => {
            if (!nav.subs || nav.subs.length === 0) return true;

            const accessibleSubs = nav.subs.filter((sub) => {
            const required = sub.requiredPermission;

            if (!required) return true;

            return required.some((permRequired) =>
                permissions.some((perm) => perm.name === permRequired)
            );
            });

            return accessibleSubs.length > 0;
        });
    };

    const accessibleNavItems = pagesNav; //getAccessibleNavItems(pagesNav, permissions);
    const accessibleCompanyNavItems = pagesCompanyNav; //getAccessibleNavItems(pagesCompanyNav, permissions);

    useEffect(() => {
        if (pathname) {
            let allPaths = pagesNav.concat(pagesCompanyNav).concat(pagesAccNav);
            for (let i = 0; i < allPaths.length; i++) {
                let path = allPaths[i];
                if (path.subs) {
                    for (let j = 0; j < path.subs.length; j++) {
                        let sub = path.subs[j];
                        if (sub.path === pathname) {
                            setCurrentNav(path.name)
                            return;
                        }
                    }
                }
            }
        } else {
            setCurrentNav("")
        }

    }, [pathname])

    const renderSubs = (subs) => {
        let render = (
            <div style={{minWidth: '180px'}}>
                {subs.map((sub, index) => (
                    <React.Fragment key={index + 10}>
                        <MenuItem
                            className={pathname === sub.path ? 'item-nav bg-secondary text-white hover:text-secondary' : 'item-nav'}
                            key={index} onClick={() => {
                                setOpenDynamic(null);
                                setAnchorElUser(null);
                                setNewNavigation(sub.path);
                            }
                        }>
                            {intl.formatMessage({id: sub.name})}
                        </MenuItem>
                        {sub?.break ? <Divider /> : null}
                    </React.Fragment>
                ))}
            </div>
        )

        return render;
    }


    const RenderMenuItems = ({ nav }) => {
        if (!nav.subs || nav.subs.length === 0) return null;

        const filteredSubs = nav.subs.filter((sub) => {
            const required = sub.requiredPermission;

            if (!required) return true;

            return required.some((permRequired) =>
            permissions?.some((perm) => perm.name === permRequired)
            );
        });

        return filteredSubs.length > 0 ? renderSubs(filteredSubs) : null;
    };



    const renderAdminNav = () => {
        let render = (
            <React.Fragment>
                {accessibleCompanyNavItems.map((nav, index) => (
                    <React.Fragment key={index + 100}>
                        <Button
                            key={'but' + index}
                            sx={{ color: 'white', display: 'block', midWidth: '180px', height: '40px' }}
                            className={currentNav === nav.name ? 'flex items-center font-sans text-white hover:text-black bg-secondary rounded-xl text-xxl normal-case' :  'flex items-center font-sans text-secondary text-xxl normal-case'}
                            onClick={(event) => {
                                setAnchorElDynamic(event.currentTarget);
                                setOpenDynamic(nav.name)
                            }}
                        >
                            {intl.formatMessage({id: nav.name})}
                        </Button>
                        <Menu
                            key={'menu' + index}
                            id="basic-menu-dynamic"
                            anchorEl={anchorElDynamic}
                            open={openDynamic === nav.name}
                            onClose={() => {
                                setOpenDynamic(null)
                            }}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                        >
                            <RenderMenuItems nav={nav} />
                        </Menu>
                    </React.Fragment>
                ))}
            </React.Fragment>
        )

        return render;
    }
    
    const handleCloseLinkedInModal = () => {
        dispatch(hideLinkedInModal());
    };

    return (
        <div className={'bdj-body-container justify-center relative flex flex-col min-h-screen'} id={'nav_container'}>
            <BannerMessage token={token} />
            {contact && contact?.profile_status != 'new' ?
                <div>
                    <AppBar position="static" className={' bg-white text-secondary'}>
                        <Container maxWidth="xxl">
                            <Toolbar disableGutters>

                                <img
                                    src={logoPath}  alt={`Logo de ${name}`}
                                    className={'ml-16 md:ml-24 w-40 flex py-2 cursor-pointer block'}
                                    onClick={() => {
                                        setCurrentNav("")
                                        navigate('/company/dashboard')
                                    }}
                                />

                                <Box className="flex-grow justify-end text-xl lg:hidden flex">
                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={handleOpenNavMenu}
                                        color="inherit"
                                    >
                                        <MenuIcon/>
                                    </IconButton>
                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorElNav}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        open={Boolean(anchorElNav)}
                                        onClose={() => {
                                            handleCloseNavMenu(null)
                                        }}
                                        sx={{
                                            display: {xs: 'block', md: 'none'},
                                        }}
                                    >
                                        {/* Navigation principale */}
                                        {accessibleNavItems
                                            .filter((nav) => !disabledPages.includes(nav.name))
                                            .map((page, index) => (
                                                <MenuItem key={index} onClick={() => {
                                                    handleCloseNavMenu(page.name)
                                                }}>
                                                    <Typography textAlign="center">{intl.formatMessage({id: page.name})}</Typography>
                                                </MenuItem>
                                            ))}


                                        <Divider />

                                        {accessibleCompanyNavItems
                                            .filter((nav) => !disabledPages.includes(nav.name))
                                            .map((nav, navIdx) =>
                                                nav.subs?.map((sub, subIdx) => (
                                                    <React.Fragment key={`company-sub-${navIdx}-${subIdx}`}>
                                                        <MenuItem
                                                            onClick={() => {
                                                                setAnchorElNav(null);
                                                                navigate(sub.path);
                                                            }}
                                                        >
                                                            <Typography textAlign="center">{intl.formatMessage({id: sub.name})}</Typography>
                                                        </MenuItem>
                                                    </React.Fragment>
                                                ))
                                            )}

                                        <Divider />

                                        {pagesAccNav[0]?.subs?.map((sub, idx) => (
                                            <MenuItem
                                                key={"accnav-mobile-"+idx}
                                                onClick={() => {
                                                    setAnchorElNav(null);
                                                    if(sub.name === 'disconnect') {
                                                        dispatch(userSignOut());
                                                    } else {
                                                        navigate(sub.path);
                                                    }
                                                }}
                                            >
                                                {intl.formatMessage({id: sub.name})}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </Box>

                                <Box className="flex-grow items-center justify-evenly text-xl lg:flex hidden">
                                    {accessibleNavItems
                                        .filter((nav) => !disabledPages.includes(nav.name))
                                        .map((nav, index) => (
                                            <React.Fragment key={index + 10}>
                                                <Button
                                                    key={'but' + index}
                                                    sx={{
                                                        color: 'white',
                                                        display: 'block',
                                                        midWidth: '180px',
                                                        height: '40px'
                                                    }}
                                                    className={currentNav === nav.name
                                                        ? 'flex items-center font-sans text-white hover:text-black bg-secondary rounded-xl text-xxl normal-case'
                                                        : 'flex items-center font-sans text-secondary text-xxl normal-case'}
                                                    onClick={(event) => {
                                                        setAnchorElDynamic(event.currentTarget);
                                                        setOpenDynamic(nav.name);
                                                    }}
                                                >
                                                    {intl.formatMessage({ id: nav.name })}
                                                </Button>
                                                <Menu
                                                    key={'menu' + index}
                                                    id="basic-menu-dynamic"
                                                    anchorEl={anchorElDynamic}
                                                    open={openDynamic === nav.name}
                                                    onClose={() => setOpenDynamic(null)}
                                                    MenuListProps={{
                                                        'aria-labelledby': 'basic-button',
                                                    }}
                                                >
                                                    <RenderMenuItems nav={nav} />
                                                </Menu>
                                            </React.Fragment>
                                        ))}

                                    {hasCompanyInfo || hasManageTeams || hasViewInvoices || hasViewCollab || hasEmployerBrand ? renderAdminNav() : null}
                                </Box>


                                <Box sx={{flexGrow: 0}}>
                                    <Button
                                        key={'but5'}
                                        sx={{color: 'white', display: 'block', maxWidth: '180px', height: '40px'}}
                                        className={currentNav === pagesAccNav[0].name ? 'hidden lg:flex items-center font-sans text-white hover:text-black bg-green-600 rounded-xl text-xxl capitalize truncate mr-24' :  'hidden lg:flex items-center font-sans text-green-600 text-xxl capitalize truncate mr-10'}
                                        onClick={handleOpenUserMenu}
                                    >
                                        {contact?.first_name}
                                    </Button>
                                    <Menu
                                        sx={{mt: '45px'}}
                                        id="menu-appbar"
                                        anchorEl={anchorElUser}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElUser)}
                                        onClose={handleCloseUserMenu}
                                    >
                                        <RenderMenuItems nav={pagesAccNav[0]} />
                                    </Menu>
                                </Box>
                            </Toolbar>
                        </Container>
                    </AppBar>
                </div>
                : ''}
            <AppRoutes/>
            {contact && contact?.profile_status != 'new' ?
                <footer className="py-4 mt-auto" style={{
                    boxShadow: "0px -2px 4px -1px rgba(0, 0, 0, 0.2), 0px -4px 5px 0px rgba(0, 0, 0, 0.14), 0px -1px 10px 0px rgba(0, 0, 0, 0.12)"
                }}>
                    <ul className="flex flex-col space-y-2 md:flex-row md:space-y-0 items-center justify-evenly">
                        {/* <li>
                        <a href={'#'} className="tawk_open" onClick={handleTawkTo}>
                                {intl.formatMessage({id: 'contact.us'})}
                            </a>
                        </li> */}

                        <li>
                            <a href={locale.short === "en" ? protectData_en : protectData_fr}
                               target="_blank" rel="noreferrer">{intl.formatMessage({id: 'protect.data'})}</a>
                        </li>

                        <li>
                            <a href={locale.short === "en" ? cguv_en : cguv_fr}
                               target="_blank" rel="noreferrer">{intl.formatMessage({id: 'cgu'})}</a>
                        </li>

                        <li>{name} &copy;</li>
                    </ul>
                </footer>
            : '' }

            {/* {showTalkTo ?
            <TawkMessengerReact propertyId={TawkToConfig.propertyId} widgetId={TawkToConfig.widgetId} ref={tawkMessengerRef}/>
                : ''}
            <CreateTicket /> */}
            {/* Remove snackbars*/}
            {/*<Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={loading_job}
                onClose={() => {

                }}
            >
                <Alert icon={<CircularProgress size={'1rem'} />} severity="warning" sx={{ width: '100%' }}>
                    <div className={'flex items-center'}>
                        {intl.formatMessage({id: 'creating.job.offer'})}...
                    </div>
                </Alert>
            </Snackbar>

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={loading_job_done}
                onClose={() => {

                }}
                className={'cursor-pointer'}
            >
                <Alert icon={<SearchIcon size={'1rem'} />} severity="success" sx={{ width: '100%' }} onClick={() => {
                    navigate(`/company/job_offer/fiche/${job_offer_id}?redirect=1`)
                    dispatch(clearJobId());
                }}>
                    <div className={'flex items-center'}>
                        {intl.formatMessage({id: 'creating.job.offer.done'})}
                    </div>
                </Alert>
            </Snackbar>
            */}
            {/* <LinkedInModal
                open={showLinkedInModalState}
                onClose={handleCloseLinkedInModal}
            /> */}
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={loading_job_error}
                onClose={() => {

                }}
                className={'cursor-pointer'}
            >
                <Alert icon={<SearchIcon size={'1rem'} />} severity="error" sx={{ width: '100%' }} onClick={() => {
                    navigate(`/company/job_offer/auto`)
                    dispatch(clearJobId());
                }}>
                    <div className={'flex items-center'}>
                        {intl.formatMessage({id: 'creating.job.offer.fail'})}
                    </div>
                </Alert>
            </Snackbar>
        </div>
    )
}

export default injectIntl(CompanyLayout)
